import logo from "../../data/images/GPML.png";
import "../../data/style/keyframes.css";

export const GPLogo = ({ size }) => {
  return (
    <img
      src={logo}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        // border: "2px solid #f97316",
      }}
      alt="Grind Partner Logo"
    />
  );
};

export const Spinner = () => {
  return (
    <svg className="spin" width="18" height="18" viewBox="0 0 18 18">
      <circle
        cx="9"
        cy="9"
        r="7"
        fill="none"
        stroke="rgba(255,255,255,.3)"
        strokeWidth="2"
      />
      <circle
        cx="9"
        cy="9"
        r="7"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="11 33"
      />
    </svg>
  );
};
